/**
 * @description Bandeau cookies
 */

/* global drupalSettings, ga, $toggle, toggleAll, keyboardNavigation, dataLayer */

/* eslint-disable no-unused-vars */

(() => {
	// VARS
	const root = document.querySelector('body');
	const yellowStoneCookies = drupalSettings.yellowstone.cookies;
	const gaProperty = yellowStoneCookies.analytics; // ID de suivie GAnalytics
	const allCookies = yellowStoneCookies.list; // Tous les cookies
	const useCategories = yellowStoneCookies.use_categories; // true ou false, utilisation ou non des catégories

	/**
	 * @description Fonction qui determine si l'entête est en https ou non , afin de mettre un flag secure ou non sur les cookies
	 */
	const isSecure = () => {
		let getSecure;
		document.location.protocol === 'https:'
			? (getSecure = 'secure;')
			: (getSecure = '');
		return getSecure;
	};

	const cookiesBanner = () => {
		let consent = false;
		let classChecked = '';
		let dismiss = 'allKo';
		let consentGA = false;
		let classCheckedGA = '';

		if (document.cookie.indexOf('hasConsent=true') > -1) {
			consent = true;
			classChecked = 'checked';
			dismiss = 'allOk';
		} else if (document.cookie.indexOf('hasConsent=choice') > -1) {
			dismiss = 'choice';
		}

		if (document.cookie.indexOf('_ga') > -1) {
			consentGA = true;
			classCheckedGA = 'checked';
		}

		const banner = `<div class="cookies__shadow"></div>
				<div id="cookieBanner" class="cookies module shadow col-lg-4 col-md-8 col-sm-12" tabindex="1" aria-modal="true" role="dialog" aria-labelledby="cookieBannerTitle">
					<div role="document">
                      <div class="cookies__title">
                          <i class="list-group-item__icon btn-icon btn-icon-secondary btn-icon" data-icon="cookies"></i>
                          <h4 id="cookieBannerTitle">Cookies</h4>
                      </div>
                      <div class="cookies__content">
                          <p>Ce site utilise des cookies pour assurer le bon fonctionnement et réaliser des statistiques de visite. En cliquant sur Accepter, vous consentez à l'utilisation de ces cookies. Vous pouvez à tout moment modifier vos préférences. Pour plus d'informations, veuillez consulter la page <a href="/node/166" aria-label="Accéder à la page de gestion des cookies">Gestion des cookies.</a></p>
                      </div>
                      <div class="cookies__choices">
                        <div class="cookies__choices__flex">
                          <button aria-describedby="cookieBannerTitle" type="button" class="btn btn-primary btn-cookies" aria-label="Selectionnez pour afficher les préfèrences" aria-expanded="false" data-cookies-choices-title>Afficher les préférences</button>
                          <div class="cookies__accept">
                            <button class="btn btn-primary btn-cookies" data-dismiss="allOk" aria-describedby="cookieBannerTitle">Tout accepter</button>
                            <button class="btn btn-secondary btn-cookies" data-dismiss="allKo" aria-describedby="cookieBannerTitle">Tout refuser</button>
                          </div>
                        </div>
                        <div class="cookies__choices__options" style="display:none;" data-cookies-choices-content>
                          <h5 class='cookies__choices__title'>Choisissez le type de cookies qui vous convient</h5>
                          <div class="cookies__cookie" data-cookies-cookie="_ga">
                            <div class="cookies__cookie__content">
                              <button type="button" class="cookies__cookie__choice ${classCheckedGA}" data-analytics data-consent=${consentGA}><span>Google analytics</span></button>
                              <div class="cookies__cookie__content--title">
                                <button type="button" class="cookies__cookie__toggle" aria-label="Afficher la description Google analytics" aria-describedby="google-desc" data-category-choices-toggle><span class="sr-only">Afficher la description Google analytics</span><i data-icon="chevron" aria-hidden="true"></i></button>
                              </div>
                            </div>
                            <div class="cookies__cookie__details">
                              <p class="cookies__cookie__text" id="google-desc" data-cookies-choices-text>Les services de mesure d'audience permettent de générer des statistiques de fréquentation utiles à l'amélioration du site.</p>
                              </div>
                            </div>
                          </div>
                        <div class="cookies__btn">
                            <button aria-describedby="cookieBannerTitle" class="btn btn-primary icon icon-right align-self-start close" type="button" aria-label="Enregistrer et fermer" data-dismiss="choice">
                                Enregistrer et fermer
                                <i data-icon="arrow" aria-hidden="true"></i>
                            </button>
                        </div>
					  </div>
					</div>
				</div>`;

		root.insertAdjacentHTML('afterbegin', banner);
		const cookiesArr = [];
		const cookiesBtn = document.querySelector('[data-set-cookies]');
		const cookiesModal = document.querySelector('.cookies');
		cookiesArr.push(cookiesModal);

		// Gestion de la touch escape
		if (cookiesBtn) {
			cookiesBtn.addEventListener('keydown', (e) => {
				if (e.key === 'Tab') {
					cookiesModal.focus();
				} else if (e.key === 'Escape') {
					keyboardNavRemove(cookiesArr, cookiesBtn);
				}
			});
		}
		cookiesModal.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				keyboardNavRemove(cookiesArr, cookiesBtn);
			}
		});

		const choices = cookiesModal.querySelector('.cookies__choices');
		const allChoicesBtn = choices.querySelectorAll('.btn-cookies');
		const saveBtn = choices.querySelector('.cookies__btn') || null;
		allChoicesBtn.forEach((btn) => {
			if (btn.getAttribute('data-dismiss') === 'allKo') {
				btn.addEventListener('keydown', (e) => {
					if (e.key === 'Tab') {
						if (
							saveBtn &&
							saveBtn.classList.contains('align-right')
						) {
							document
								.querySelector('.cookies__choices__options')
								.focus();
						} else {
							cookiesModal.focus();
						}
					}
				});
			}
		});
		saveBtn.addEventListener('keydown', (e) => {
			if (e.key === 'Tab') {
				cookiesModal.focus();
			}
		});
	};

	const keyboardNavRemove = (elements, elToFocus) => {
		if (elements) {
			elements.forEach((el) => {
				if (el) {
					el.remove();
				}
			});
			elToFocus.focus();
		}
	};

	// FUNCTION

	// Function to sort an object by key
	const sortObjects = (obj) => {
		let sortOrder = 1;

		if (obj[0] === '-') {
			sortOrder = +1;
			obj = obj.substr(1);
		}
		return function (a, b) {
			if (sortOrder === +1) {
				return b[obj].localeCompare(a[obj]);
			} else {
				return a[obj].localeCompare(b[obj]);
			}
		};
	};

	// Function to get all categories of cookies
	const getCategories = () => {
		const categories = [];

		allCookies.forEach((el) => {
			const category = el.category;

			if (category.id === '') {
				category.id = 'autre';
				category.label = 'Autre';
			}

			categories.push(category);
		});

		const uniqCat = [];

		categories.forEach((categorie) => {
			let i = 0;

			categories.forEach((valueCat) => {
				if (valueCat.id === categorie.id) {
					i++;
				}
			});

			if (i > 1) {
				uniqCat.push(categorie);
			}
		});

		return uniqCat;
	};

	// Function to put uniq category object in array
	const uniqCategories = () => {
		const uniqCategory = {};
		const uniqCategories = [];

		getCategories().forEach((cat) => {
			const category = cat.id;
			uniqCategory[category] = cat;
		});

		for (const cat in uniqCategory) {
			uniqCategories.push(uniqCategory[cat]);
		}

		return uniqCategories;
	};

	// Function to sort categories by id
	const sortUniqCategories = () => {
		return uniqCategories().sort(sortObjects('id'));
	};

	// Function to build all categories in DOM
	const buildCategories = () => {
		sortUniqCategories().forEach((cat) => {
			const section = document.querySelector(
				'.cookies__choices__options'
			);

			const label =
				cat.label.charAt(0).toUpperCase() + cat.label.slice(1); // capitalize
			const desc = cat.description || null;
			const descIsPresent = desc || '';
			const systemName = cat.id;
			const allChecked = true;
			const classChecked = 'checked';

			const createCategory = `<div class="cookies__cookie has__cookies">
                                  <div class="cookies__cookie__content">
                                    <button type="button" class="cookies__cookie__choice ${classChecked}" data-consent=${allChecked} data-category-choices data-category="${cat.id}"><span>${label}</span></button>
                                    <div class="cookies__cookie__content--title">
                                      <button type="button" class="cookies__cookie__toggle" aria-label="afficher la description ${label}" aria-describedby="${systemName}-desc" data-category-choices-toggle><span class="sr-only">Afficher la description ${label}</span><i data-icon="chevron" aria-hidden="true"></i></button>
                                    </div>
                                  </div>
                                  <div class="cookies__cookie__details">
                                    <p class="cookies__cookie__text" id="${systemName}-desc" data-cookies-choices-text>${descIsPresent}</p>
                                  </div>
                                </div>`;
			section.insertAdjacentHTML('beforeEnd', createCategory);
		});
	};

	// Function to build all cookies under categories in DOM
	const buildCookies = () => {
		allCookies.sort(sortObjects('id')).forEach((el) => {
			const category = el.category;
			const statut = el.statut;
			const desc = el.desc || null;
			const sectionCategory = document.querySelector(
				`[data-category="${category.id}"]`
			);
			const label = el.label.charAt(0).toUpperCase() + el.label.slice(1); // capitalize
			const systemName = el.id;
			let section = document.querySelector('.cookies__choices__options');
			let classCategory = '';
			const classDesc = desc ? 'd-block' : 'd-none';

			// ajout des classes checked sur les toggles et set le data consent, tenant compte de la réouverture du bandeau depuis la page des modalités
			let classChecked;
			let dataConsent;
			if (
				document.cookie.indexOf(`${el.id}=true`) > -1 ||
				document.cookie.indexOf('hasConsent=true') > -1
			) {
				classChecked = 'checked';
				dataConsent = true;
			} else {
				classChecked = '';
				dataConsent = false;
			}

			if (useCategories && sectionCategory) {
				section = sectionCategory
					.closest('.has__cookies')
					.querySelector('.cookies__cookie__details');

				classCategory = 'has__category';
			}

			const createCookie = `<div class="cookies__cookie ${classCategory}" data-cookies-cookie="${el.id}">
                              <div class="cookies__cookie__content">
                                <div class="cookies__cookie__list"></div>
                                <button type="button" class="cookies__cookie__choice ${classChecked}" data-consent="${dataConsent}" data-cookies-category="${category.id}"><span>${label}<span></button>
                                <div class="cookies__cookie__content--title">
                                  <button type="button" class="cookies__cookie__toggle ${classDesc}" aria-label="afficher la description ${label}" aria-describedby="${systemName}-desc" data-cookies-choices-toggle><span class="sr-only">Afficher la description ${label}</span><i data-icon="chevron" aria-hidden="true"></i></button>
                                </div>
                              </div>
                              <div class="cookies__cookie__details">
                                <p class="cookies__cookie__text" id="${systemName}-desc" data-cookies-choices-text>${el.desc}</p>
                                </div>
                              </div>
                            </div>`;

			section.insertAdjacentHTML('beforeEnd', createCookie);
		});
	};

	// ajouter le data-consent et la class checked en fonctions de ses cookies et du consentement précédant
	const setCheckedCategory = () => {
		const categories = document.querySelectorAll(`[data-category]`);

		categories.forEach((cat) => {
			const attr = cat.getAttribute('data-category');
			const children =
				document.querySelectorAll(`[data-cookies-category=${attr}]`) ||
				null;
			if (
				document.cookie.indexOf('hasConsent') === -1 ||
				document.cookie.indexOf('hasConsent=false') > -1
			) {
				cat.classList.remove('checked');
				cat.setAttribute('data-consent', false);
			}

			children.forEach((child) => {
				if (child.getAttribute('data-consent') === 'false') {
					cat.classList.remove('checked');
					cat.setAttribute('data-consent', false);
				}
			});
		});
	};

	// Function to set extend attributes on chevron
	const setExtend = (chevron) => {
		chevron.setAttribute('data-toggle-status', 'inactive');
		chevron.setAttribute('aria-expanded', 'false');
	};

	// Function to unset extend attributes on chevron
	const unsetExtend = (chevron) => {
		chevron.setAttribute('data-toggle-status', 'active');
		chevron.setAttribute('aria-expanded', 'true');
	};

	// Function to extend all cookies of a category when click on chevron button
	const extendCategory = () => {
		const toggleCategories = document.querySelectorAll(
			`[data-category-choices-toggle]`
		);
		const cookies = document.querySelectorAll('.cookies__cookie');

		toggleCategories.forEach((el) => {
			const category = el.closest('.cookies__cookie');
			const details = category.querySelector('.cookies__cookie__details');

			el.addEventListener('click', () => {
				if (el.getAttribute('data-toggle-status') === 'active') {
					setExtend(el);
					category.classList.remove('active');
					details.style.display = 'none';
				} else {
					cookies.forEach((cookie) => {
						const details = cookie.querySelector(
							'.cookies__cookie__details'
						);
						const toggle = cookie.querySelector(
							'.cookies__cookie__toggle'
						);

						details.style.display = 'none';
						cookie.classList.remove('active');
						setExtend(toggle);
					});
					unsetExtend(el);
					category.classList.add('active');
					details.style.display = 'block';
				}
			});
		});
	};

	// Function to extend details of a cookie when click on chevron button
	const extendCookie = () => {
		const toggleCookies = document.querySelectorAll(
			`[data-cookies-choices-toggle]`
		);

		toggleCookies.forEach((el) => {
			const cookie = el.closest('[data-cookies-cookie]');
			const details = cookie.querySelector('.cookies__cookie__details');

			el.addEventListener('click', () => {
				if (el.getAttribute('data-toggle-status') === 'active') {
					setExtend(el);
					cookie.classList.remove('active');
					details.style.display = 'none';
				} else {
					unsetExtend(el);
					cookie.classList.add('active');
					details.style.display = 'block';
				}
			});
		});
	};

	// Function to extend all categories and cookies preferences
	const extendPreferences = () => {
		root.querySelector(`[data-cookies-choices-title]`).addEventListener(
			'click',
			() => {
				const el = root.querySelector(`[data-cookies-choices-content]`);
				const chevron = root.querySelector(
					`[data-cookies-choices-title]`
				);
				$toggle(el, 'block');
				if (chevron.getAttribute('data-toggle-status') === 'active') {
					setExtend(chevron);
					document
						.querySelector('.cookies__btn')
						.classList.remove('align-right');
					document.querySelector('body').style.overflow = 'inherit';
					document.querySelector('.cookies__shadow').style.display =
						'none';
				} else {
					const consent = document.querySelectorAll('[data-dismiss]');

					unsetExtend(chevron);
					document
						.querySelector('.cookies__btn')
						.classList.add('align-right');
					// document.querySelector('body').style.overflow = 'hidden';
					document.querySelector('.cookies__shadow').style.display =
						'block';
					document
						.querySelectorAll('.cookies__cookie__choice ')[0]
						.focus();
				}
			}
		);
	};

	const keyBoardNav = () => {
		if (document.querySelector('.cookies')) {
			document.addEventListener('keydown', function (e) {
				const isTabPressed = e.key === 'Tab';
				if (!isTabPressed) {
					return;
				}

				if (
					document.activeElement ===
					document.querySelector('.cookies [data-dismiss="allKo"]')
				) {
					e.preventDefault();
					document
						.querySelectorAll('.cookies__cookie__choice')[0]
						.focus();
				}
			});

			keyboardNavigation(
				document.querySelector('.cookies'),
				document.querySelector('.cookies [data-dismiss="allKo"]')
			);

			document
				.querySelector('[data-cookies-choices-title]')
				.addEventListener('click', () => {
					if (
						root.querySelector(`[data-cookies-choices-content]`)
							.style.display === 'none'
					) {
						keyboardNavigation(document.querySelector('.cookies'));
					} else {
						keyboardNavigation(
							document.querySelector('.cookies'),
							document.querySelector(
								'.cookies [data-dismiss="allKo"]'
							)
						);
					}
				});
		}
	};

	// Function to set all classes and attributes when click on toggle button
	const setToggle = (button) => {
		button.classList.add('checked');
		button.setAttribute('data-consent', 'true');
		button.setAttribute('aria-pressed', 'true');
	};

	// Function to unset all classes and attributes when click on toggle button
	const unsetToggle = (button) => {
		button.classList.remove('checked');
		button.setAttribute('data-consent', 'false');
		button.setAttribute('aria-pressed', 'false');
	};

	// Fonction de changement de consentement d'un cookie (n'a pas de parent s'il n'utilise pas de catégorie)
	const toggleCookies = (choice) => {
		const dismiss = document.querySelector('[data-dismiss]');
		const category = choice.getAttribute('data-cookies-category') || null;
		const parent =
			document.querySelector(`[data-category= ${category}]`) || null;

		if (choice.classList.contains('checked')) {
			unsetToggle(choice);
			if (parent) {
				unsetToggle(parent);
			}
		} else {
			setToggle(choice);
		}
	};

	const toggleCategory = (choice) => {
		const dismiss = document.querySelector('[data-dismiss]');
		const category = choice.getAttribute('data-category');
		const children = document.querySelectorAll(
			`[data-cookies-category= ${category}]`
		);
		const toggleAllButton = document.querySelector(
			'[data-toggle-all-cookies]'
		);

		if (choice.classList.contains('checked')) {
			children.forEach((child) => {
				unsetToggle(child);
			});
			unsetToggle(choice);
			unsetToggle(toggleAllButton);
		} else {
			children.forEach((child) => {
				setToggle(child);
			});
			setToggle(choice);
		}
	};

	const activeAnalytics = () => {
		if (gaProperty.charAt(0) === 'G') {
			const gtagScript = document.createElement('script');
			gtagScript.setAttribute('type', 'text/javascript');
			gtagScript.async = true;
			gtagScript.id = 'gtag';
			gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaProperty}`;
			document.head.appendChild(gtagScript);
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}
			gtag('js', new Date());
			gtag('config', gaProperty, {
				cookie_flags: `domain=${document.location.hostname};`,
			});
		} else {
			(function (i, s, o, g, r, a, m) {
				i.GoogleAnalyticsObject = r;
				// eslint-disable-next-line no-unused-expressions
				(i[r] =
					i[r] ||
					function () {
						(i[r].q = i[r].q || []).push(arguments);
						// eslint-disable-next-line no-sequences
					}),
					(i[r].l = 1 * new Date());
				// eslint-disable-next-line no-unused-expressions, no-sequences
				(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
				a.async = 1;
				a.src = g;
				m.parentNode.insertBefore(a, m);
			})(
				window,
				document,
				'script',
				'https://www.google-analytics.com/analytics.js',
				'ga'
			);
			ga('create', gaProperty, document.location.hostname);
			ga('send', 'pageview');
		}
	};

	const activeAll = () => {
		activeAnalytics();
		allCookies.forEach((cookie) => {
			const cookieName = cookie.id;
			activeCookie(cookieName); // name and number of days untill cookie expires
		});
	};

	const expirationDate = () => {
		const days = 395; // RGPD date expiration à 13 mois
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		date.toGMTString();
		return date;
	};

	const activeCookie = (cookie) => {
		const expiration = expirationDate();
		const options = 'expires=' + expiration + ';path=/;' + isSecure();
		document.cookie = cookie + '=true;' + options;
	};
	/** @description Fonction utile pour récupérer un cookie à partir de son nom
	 *
	 * @param NameOfCookie
	 * @returns {string|null}
	 */
	const getCookie = (NameOfCookie) => {
		if (document.cookie.length > 0) {
			let begin = document.cookie.indexOf(`${NameOfCookie}=`);
			if (begin !== -1) {
				begin += NameOfCookie.length + 1;
				let end = document.cookie.indexOf(';', begin);
				if (end === -1) end = document.cookie.length;
				return unescape(document.cookie.substring(begin, end));
			}
		}
		return null;
	};

	/** @description Fonction d'effacement des cookies
	 * avec nom de cookie spécifique dans un tableau
	 * ou le préfix dans le tableau avec la variable prefix à true pour une gestion par lot
	 * @param name
	 * @param prefix
	 */
	const delCookie = (cookie) => {
		const path = ';path=' + '/';
		const expiration = 'Thu, 01-Jan-1970 00:00:01 GMT';
		document.cookie = `${cookie}=${path};expires=${expiration}`;
	};

	/** @description Efface tous les types de cookies utilisés par Google Analytics
	 */
	const deleteAnalyticsCookies = () => {
		const gtag = document.head.querySelector('script#gtag') || null;
		const cookieNames = [
			`_ga_${gaProperty.substring(2)}`,
			'__utma',
			'__utmb',
			'__utmc',
			'__utmt',
			'__utmv',
			'__utmz',
			'_ga',
			'_gat',
			'_gid',
		];

		const path = ';path=' + '/';
		let { hostname } = document.location;
		if (!hostname.indexOf('www.') === -1) hostname = hostname.substring(4);
		const domain = `${';domain=' + '.' + hostname}`;
		const expiration = 'Thu, 01-Jan-1970 00:00:01 GMT';

		for (let i = 0; i < cookieNames.length; i++) {
			document.cookie = `${cookieNames[i]}=${path}${domain};expires=${expiration}`;
		}

		if (gtag) {
			gtag.remove();
		}

		window[`ga-disable-${gaProperty}`] = true; // spé pour GAnalytics
	};

	/** @description Efface tous les types de cookies [ sauf GAnalytics ] */
	const delAllCookie = () => {
		deleteAnalyticsCookies();

		const theCookies = document.cookie.split(';');

		for (let i = 0; i < theCookies.length; i++) {
			let completeCookie;
			if (theCookies[i].substr(0, 1) === ' ') {
				completeCookie = theCookies[i].substr(1);
			} else {
				completeCookie = theCookies[i];
			}

			const cookie = theCookies[i].split('=');
			if (
				completeCookie.split('=')[0] !== 'hasConsent' &&
				completeCookie.split('=')[0] !== 'notifStatut'
			) {
				const path = ';path=' + '/';
				const expiration = 'Thu, 01-Jan-1970 00:00:01 GMT';

				document.cookie = `${cookie[0]}=${path};expires=${expiration}`;
			}
		}
	};

	const cookies = () => {
		const consentCookie = getCookie('hasConsent');

		if (consentCookie) {
			// Si hasConsent a true on active tous les cookies
			// si false on active aucun cookie
			// si choice, on regarde les autres cookies
			if (document.cookie.indexOf('hasConsent=true') > -1) {
				activeAll();
			} else if (document.cookie.indexOf('hasConsent=choice') > -1) {
				// Gestion du cookie Google analytics
				if (document.cookie.indexOf('_ga=true') > -1) {
					activeAnalytics();
				} else if (document.cookie.indexOf('_ga=false') > -1) {
					deleteAnalyticsCookies(); // spé pour GAnalytics
				}
			} else {
				delAllCookie();
			}
		} else {
			cookiesBanner();
			if (useCategories === true) {
				buildCategories();
			}
			buildCookies();
			if (useCategories) {
				setCheckedCategory();
			}
		}
	};

	/**
	 * @description Fonction qui ferme la bannière en enregistrant le consentement
	 */
	const closeCnil = (e) => {
		const allCookies = document.querySelectorAll('[data-cookies-cookie]');
		const consent = e.target.getAttribute('data-dismiss');
		const expiration = expirationDate();
		const options = 'expires=' + expiration + ';path=/;' + isSecure();
		const hasConsentOptions = 'expires=' + expiration + ';path=/;';

		if (consent === 'allOk') {
			document.cookie = 'hasConsent=true;' + hasConsentOptions;
			activeAll();
		} else if (consent === 'allKo') {
			document.cookie = 'hasConsent=false;' + hasConsentOptions;
			delAllCookie();
		} else {
			document.cookie = 'hasConsent=choice;' + hasConsentOptions;
			allCookies.forEach((cookie) => {
				const cookieName = cookie.getAttribute('data-cookies-cookie');
				const status = cookie
					.querySelector('[data-consent]')
					.getAttribute('data-consent');
				if (cookieName === '_ga') {
					if (status === 'false') {
						deleteAnalyticsCookies();
					} else {
						activeAnalytics();
					}
				} else if (status === 'true') {
					activeCookie(cookieName);
				} else {
					delCookie(cookieName);
				}
			});
		}

		document.querySelector('.cookies').remove();
		document.querySelector('.cookies__shadow').remove();
	};

	// initialise les fonctions permettant les différentes actions dans le bandeau (toggle, extend, closeCnil)
	// resize le bandeau
	const setCookies = () => {
		const div = document.querySelector('.cookies') || null;

		if (div) {
			div.style.right = `calc(50% - ${div.offsetWidth / 2}px)`;

			extendPreferences();
			extendCategory();
			extendCookie();

			root.querySelector(`.cookies`).addEventListener('click', (e) => {
				const consent = e.target.getAttribute('data-dismiss');
				const choice = e.target.getAttribute('data-consent');
				const toggleAllButton = e.target.hasAttribute(
					'data-toggle-all-cookies'
				);
				const category = e.target.hasAttribute('data-category');

				if (consent) {
					closeCnil(e);
				}

				if (choice) {
					if (toggleAllButton) {
						toggleAll(e.target);
					} else if (category) {
						toggleCategory(e.target);
					} else {
						toggleCookies(e.target);
					}
				}
			});
		}
	};

	// GO 🚀
	const init = () => {
		cookies();

		// keyBoardNav();

		const setCookiesBtn =
			document.querySelector('[data-set-cookies]') || null;

		// ouvre le bandeau cookies dans la page des modalités des cookies et initalise les fonctions toggle, extend, closeCnil
		if (setCookiesBtn) {
			setCookiesBtn.addEventListener('click', () => {
				const banner = document.querySelector('.cookies') || null;
				if (banner === null) {
					cookiesBanner();
					// keyBoardNav();
					if (useCategories) {
						buildCategories();
					}
					buildCookies();
					setCookies();
					if (useCategories) {
						setCheckedCategory();
					}
				}
			});
		}

		setCookies();
	};

	init();

	// Tag Google Analytics
	// eslint-disable-next-line no-use-before-define
	const _gaq = _gaq || [];
	_gaq.push(['_setAccount', gaProperty]);
	_gaq.push(['_trackPageview']);

	(function () {
		const ga = document.createElement('script');
		ga.type = 'text/javascript';
		ga.async = true;
		ga.src = `${
			document.location.protocol === 'https:'
				? 'https://ssl'
				: 'http://www'
		}.google-analytics.com/ga.js`;
		const s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(ga, s);
	})();
})();
